// Third party libraries
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// Constants
import { PAYMENT_FREQUENCY_DISPLAY, DOG_PURCHASE_STATUS, SUBSCRIPTION_STATUS } from '@/app/constants/constants';


export default {
	install(Vue, options) {
		// Plugin: vue2-filters
		// Filters: capitalize, uppercase, lowercase, placeholder, truncate, currency, pluralize, ordinal, limitBy, filterBy, find, orderBy
		// Link: https://www.npmjs.com/package/vue2-filters

		// TEXT AND NUMBERS
		// numbers to string
		Vue.filter('numbersToString', number => {
			if (number === 0 || number === '0') {
				return 'No';
			} else if (number === 1 || number === '1') {
				return 'Yes';
			}
		});

		// round numbers
		Vue.filter('roundNumbers', (number,fixPoint) => {
			return parseFloat(number.toFixed(fixPoint||2));
		});

		// round number
		Vue.filter('displayPrice', (number,fixPoint) => {
			if (number) {
				return parseFloat(number).toFixed(fixPoint||2);
			} else {
				return '0.00';
			}
		});

		// SIZE
		// format size
		Vue.filter('formatSize', size => {
			// 1TB
			if (size > 1024 * 1024 * 1024 * 1024) {
				return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
				// 1GB
			} else if (size > 1024 * 1024 * 1024) {
				return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
				// 1MB
			} else if (size > 1024 * 1024) {
				return (size / 1024 / 1024).toFixed(2) + ' MB'
				// 1KB
			} else if (size > 1024) {
				return (size / 1024).toFixed(2) + ' KB'
			}
			// 1B
			return size.toString() + ' B'
		});


		// LIST
		// array to list
		Vue.filter('arrayToList', (array, seperator) => {
			if (array && array.length > 0) {
				if (typeof array !== 'string') {
					return array.join(`${seperator} `);
				} else {
					return array;
				}
			}
		});

		// DATE
		// date and time display format
		Vue.filter('dateTime', (date, timeZone, dateFormat) => {
			const df = dateFormat ? dateFormat : 'dd-MMM-yyyy HH:mm a';
			const datetime = timeZone ? format(utcToZonedTime(date, timeZone), df) : format(date, df);
			return datetime;
		});

		// date and time display format
		Vue.filter('formatDate', date => {
			if (date) {
				return format(new Date(date), 'dd-MMM-yyyy');
			}
		});

		// status display format
		Vue.filter('showStatusTextAdmin', status => {
			if (status) {
				switch (status) {
					case 'A':
						return 'Removed Content';
					case 'I':
						return 'Remained Content';
					default:
						return 'Pending Request';
				}
			}
		});

		Vue.filter('parseProductAge', age => {
			if (age) {
				switch (age) {
					case 'A':
						return 'Adult';
					case 'P':
						return 'Puppy';
				}
			}
		});

		Vue.filter('showSubscriptionStatusText', status => {
			if (status) {
				switch (status) {
					case 'A':
					case 'ACTIVE':
						return 'Active';
					case SUBSCRIPTION_STATUS.CANCELLED:
						return 'Cancelled';
					case 'I':
						return 'Inactive';
					case SUBSCRIPTION_STATUS.FOR_CANCELLATION:
						return 'FOR CANCELLATION';
					case SUBSCRIPTION_STATUS.DELETED:
						return 'DELETED';
					case SUBSCRIPTION_STATUS.ENDED:
						return 'ENDED';
				}
			}
		});

		Vue.filter('translateFrequency', frequency => {
			if (frequency) {
				return PAYMENT_FREQUENCY_DISPLAY[frequency];
			}
		});


		Vue.filter('translateDogPurchaseStatus', status => {
			if (status) {
				return DOG_PURCHASE_STATUS[status] ? DOG_PURCHASE_STATUS[status] : `Unknown Status: ${status}`;
			}

			return `No status provided`;
		})
	}
}
